var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-4", class: _vm.errorShow ? "error" : "" },
    [
      _c("div", { staticClass: "input-number-wrapp" }, [
        _c("div", { staticClass: "flex items-center mb-2" }, [
          _c("label", { attrs: { for: _vm.returnName } }, [
            _c("span", [
              _c("span", { staticClass: "opacity-50" }, [
                _vm._v(_vm._s(_vm.label)),
              ]),
              _vm._v(" "),
              _vm.required
                ? _c("span", { staticClass: "text-red text-lg leading-none" }, [
                    _vm._v("*"),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.tooltip
            ? _c("span", { staticClass: "tooltip top" }, [
                _c(
                  "button",
                  {
                    staticClass: "tooltip-icon",
                    attrs: { type: "button", "aria-label": "info" },
                  },
                  [
                    _c("svg", { staticClass: "w-[6px] h-2" }, [
                      _c("use", { attrs: { "xlink:href": "#icon-question" } }),
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "tooltip-arrow" }),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "tooltip-popup" }, [
                  _vm._v(_vm._s(_vm.tooltip)),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "relative h-16 md:h-[72px]" }, [
          _c(
            "button",
            {
              staticClass:
                "absolute left-[5px] top-[5px] bottom-[5px] w-20 flex items-center justify-center border border-transparent active:scale-[0.95] outline-none duration-200",
              class:
                _vm.theme === "blue"
                  ? "bg-gray/10 hover:border-white/40 focus-visible:border-white"
                  : "bg-gray hover:border-blue focus-visible:border-blue/70",
              attrs: { type: "button", "aria-label": "minus" },
              on: {
                click: function ($event) {
                  return _vm.sub()
                },
              },
            },
            [_c("span", { staticClass: "block w-5 h-px bg-current" })]
          ),
          _vm._v(" "),
          _c("input", {
            staticClass:
              "block h-full w-full text-base text-current font-medium text-center px-24 input-border focus-visible:border-current !outline-none duration-200",
            attrs: {
              type: "number",
              id: _vm.returnName,
              name: _vm.returnName,
              placeholder: " ",
              min: _vm.min,
              max: _vm.max,
              maxlength: "4",
              autocomplete: "off",
            },
            domProps: { value: _vm.value },
            on: { input: _vm.inputChange },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "absolute right-[5px] top-[5px] bottom-[5px] w-20 flex items-center justify-center border border-transparent active:scale-[0.95] outline-none duration-200",
              class:
                _vm.theme === "blue"
                  ? "bg-gray/10 hover:border-white/40 focus-visible:border-white"
                  : "bg-gray hover:border-blue focus-visible:border-blue/70",
              attrs: { type: "button", "aria-label": "plus" },
              on: {
                click: function ($event) {
                  return _vm.add()
                },
              },
            },
            [
              _c("span", { staticClass: "block w-5 h-px bg-current" }),
              _vm._v(" "),
              _c("span", { staticClass: "absolute block h-5 w-px bg-current" }),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.errorShow
        ? _c("p", { staticClass: "text-xs text-red" }, [
            _vm._v(_vm._s(_vm.errorText)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }